// export var baseBackUrl = "http://10.0.80.9:8080/";

// export var baseFrontUrl = "http://10.0.80.9:8081/";

// export var baseBackUrl = "http://192.168.0.171:8080/";

// export var baseFrontUrl = "http://192.168.0.171:8081/";

export var baseBackUrlC2T = "https://gd-jin.upintelligence.es/";
//export var baseBackUrl = "http://localhost:8080/";
export var baseBackUrl = "https://gd-jin.upintelligence.es/";

export var baseFrontUrl = "http://localhost:8081/";


// WEBPACK FOOTER //
// ./src/assets/linkTree.js